import type { JSX } from 'react'

import { NoteCheckIcon, NoteDotIcon } from '@buffer-mono/popcorn'

/** The icon for a Note read-state action: a tick to mark read, a dot to mark unread. */
export function NoteReadStateIcon({
  state,
}: {
  state: 'read' | 'unread'
}): JSX.Element {
  return state === 'read' ? <NoteCheckIcon /> : <NoteDotIcon />
}
